import styled from 'styled-components';

export const VerifyUserModalWRapper = styled.div`
  display: flex;

  flex-direction: column;
  align-items: center;
  padding: 0 2rem 3.6rem 2rem;
  ${({ theme }) => theme.media.laptop`
  padding: 0 3.6rem 3.6rem 3.6rem;
  `}
  max-width: 50rem;
  justify-self: center;
`;

export const InfoIcon = styled.img`
  width: 8rem;
  height: 8rem;
  margin-top: -4rem;
  margin-bottom: 1.6rem;
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding: 1.6rem 3.9rem 1.6rem 3.9rem;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  border-radius: ${({ theme }) => theme.borderRadius.x4};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  align-items: center;
  justify-content: center;

  margin-top: 2.4rem;
  gap: 1.2rem;
`;
